import { Alert, TextContent } from '@amzn/awsui-components-react-v3';
import React, { useEffect, useState } from 'react';
import { Advisory } from 'aws-sdk/clients/awsdlomni';
import { safelyRenderedAdvisoryMarkdownContent } from 'src/components/dataadvisory/constants';
import { addDismissedAdvisory, getDismissedAdvisories } from 'src/components/dataadvisory/announcements/common';

export interface GlobalAnnouncementAlertProps {
  // passed in from App component from a listAdvisories call, these will be filtered by which advisories the user has already dismissed
  advisories: Advisory[];
}

export const GlobalAnnouncementAlert = (props: GlobalAnnouncementAlertProps) => {
  const getAdvisoriesToDisplay = async () => {
    const dismissedAdvisories = await getDismissedAdvisories();

    let advisories = [];
    if (props.advisories?.length > 0) {
      advisories = props.advisories.filter((advisory) => !dismissedAdvisories.includes(advisory.advisoryId));
    }

    setAdvisoriesToDisplay(advisories);
  };

  const [advisoriesToDisplay, setAdvisoriesToDisplay] = useState([]);

  // add the advisory ID to the dismissed advisories in browser storage, and set state accordingly
  const handleDismiss = async (advisory: Advisory) => {
    await addDismissedAdvisory(advisory);
    await getAdvisoriesToDisplay();
  };

  // re-render when there is a change in global advisories in props.
  useEffect(() => {
    getAdvisoriesToDisplay();
  }, [props.advisories]);

  if (advisoriesToDisplay.length == 0) {
    return <></>;
  }
  const advisory: Advisory = advisoriesToDisplay[0];
  return (
    <Alert type={'info'} header={advisory.title} dismissible={true} onDismiss={() => handleDismiss(advisory)}>
      {advisory.content.format == 'Markdown' ? (
        safelyRenderedAdvisoryMarkdownContent(advisory.content.rawContent)
      ) : (
        <TextContent>{advisory.content.rawContent}</TextContent>
      )}
    </Alert>
  );
};
